module.exports = __webpack_public_path__ + "img/error.2d5e720f.png";